<div class="flex flex-col p-10">
  <div class="flex justify-between mb-[-20px] relative">
    <div>
      <p class="text-lg font-semibold mb-2">
        <ng-content select="[title]"></ng-content>
      </p>
      <p class="text-black-light text-base">
        <ng-content select="[subtitle]"></ng-content>
      </p>
    </div>
    @if (!noCloseIcon()) {
    <app-icon name="heroXMark" size="medium" class="text-gray-400 cursor-pointer" (click)="close()"></app-icon>
    }
  </div>
  <ng-content></ng-content>
</div>
